const actionTypeIdentifier = 'B3E75719-6AF3-40B7-8F92-3CA8F37F8756'; //action identifier should be unique

export const getCircuitData = `GET_CIRCUIT_DATA-${actionTypeIdentifier}`;
export const getCircuitDataUsage = `GET_CIRCUIT_DATA_USAGE-${actionTypeIdentifier}`;
export const triggerIsPrimaryIndicator = `TRIGGER_IS_PRIMARY_INDICATOR-${actionTypeIdentifier}`;
export const showCircuitError = `SHOW_CIRCUIT_ERROR-${actionTypeIdentifier}`;
export const showUsageDetailsError = `SHOW_USAGE_SPEND_DETAILS_ERROR-${actionTypeIdentifier}`;
export const showSetAsPrimaryLoader = `SHOW_SET_AS_PRIMARY_LOADER-${actionTypeIdentifier}`;
export const setIsFetching = `SET_IS_FETCHING-${actionTypeIdentifier}`;
export const setIsUsageDetailsFetching = `SET_USAGE_SPEND_DETAILS_IS_FETCHING-${actionTypeIdentifier}`;
export const setIsShowUsageDetails = `SHOW_USAGE_SPEND_DETAILS-${actionTypeIdentifier}`;
export const setNoExchangeRate = `SET_NOEXCHANGERATE-${actionTypeIdentifier}`;
export const setIsNoSubscription = `SET_NOSUBSCRIPTION-${actionTypeIdentifier}`;
export const setUsageMonthOptions = `SET_USAGEMONTH_OPTIONS-${actionTypeIdentifier}`;
export const setUsageMonthSelected = `SET_USAGEMONTH_SELECTED-${actionTypeIdentifier}`;
export const setUsageSpendLineData = `SET_USAGESPEND_LINEDATA-${actionTypeIdentifier}`;
export const setUsageSpendBarData = `SET_USAGESPEND_BARDATA-${actionTypeIdentifier}`;
export const setUsageSpendCurrMonthTotal = `SET_USAGESPEND_CURRMONTHTOTAL-${actionTypeIdentifier}`;